import { Injectable } from '@angular/core';
import { AssetType } from "@app/shared/models/assetType";
import { DomSanitizer,SafeResourceUrl } from '@angular/platform-browser';

export const studioModes = {
  CREATE: 'studio-create',
  MODIFY:'studio-modify',
};

export const studioAssetTypes = {
  PRICE_POINT_TEMPLATE: {code:'studio-pp',name:'Price Point Template', uriLoc:'pp'} as AssetType,
  OFFER_TEMPLATE: {code:'studio-offer', name:'Offer Template', uriLoc:'ot'} as AssetType,
  SYMBOL_TEMPLATE: {code:'studio-symbol-template', name:'Symbol Template', uriLoc:'st'} as AssetType,
  STUDIO_SYMBOL: {code:'studio-symbol', name:'Studio Symbol', uriLoc:'symbol'} as AssetType,
  STUDIO_MEDIA: {code:'studio-media', name:'Studio Media', uriLoc:'media'} as AssetType,
  STUDIO_TEXT: {code:'studio-text', name:'Studio Text', uriLoc:'text'} as AssetType,
  STUDIO_ICON: {code:'studio-icon', name:'Studio Icon', uriLoc:'icon'} as AssetType,
  PAGE_TEMPLATE: {code:'studio-page', name:'Page Template', uriLoc:'segment'} as AssetType,
  BG_ARTWORK: {code:'studio-bg-artwork', name:'Page Background', uriLoc:'segment'} as AssetType,
  ALLOC_OFFER: {code:'studio-offer_alloc', name:'Allocation', uriLoc:'alloc'} as AssetType,
  UNALLOC_OFFER: {code:'studio-unalloc-offer', name:'Unallocated Offer', uriLoc:'offers'} as AssetType,
  FAVE_OFFERS: {code:'studio-fave-offers', name:'Favourite Offer', uriLoc:'fave'} as AssetType,
  SETTINGS: {code:'studio-asset-setting', name:'Setting', uriLoc:'setting'} as AssetType,
}


@Injectable()
export class StudioUtils{

  constructor(private sanitizer:DomSanitizer){};

  getSafeUrl(url):SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  convertToGridsterArray(val:string):any{

    let tempArr = JSON.parse(val);
    let gridsterArr = [];
    let idx = 0;
    for(let item of tempArr){
      let cell = {id:idx,
                  cols:(item.size_x),
                  rows:(item.size_y),
                  y:item.row-1,
                  x:item.col-1,
                  offerTemplate:null,
                  offer:null}
      gridsterArr.push(cell);
      ++idx;
    }

    return gridsterArr;

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/utils/studio-utils.ts